import * as React from "react";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import {FlagDto} from "../../../services/Client";
import Textfield from "../../../components/TextField";
import {Table, Modal} from "semantic-ui-react";
import Button from "../../../components/Button";
import {translate} from "react-i18next";

interface ITextFlagCreationDialogProps extends ITranslatedComponent {
    /** Callback when the user exits the dialog. */
    onExitDialog: (newSpec?: FlagDto) => any;
}

interface ITextFlagCreationDialogState {
    textLabel: string;
}

class TextFlagCreationDialog extends React.Component<ITextFlagCreationDialogProps, ITextFlagCreationDialogState> {

    constructor(props: ITextFlagCreationDialogProps) {
        super(props);

        this.state = {
            textLabel: "",
        };
    }

    onClickCreate = (): void => {
        if (this.props.onExitDialog) {
            const newFlag: FlagDto = {
                textLabel: this.state.textLabel.trim(),
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            };
            this.props.onExitDialog(newFlag);
        }
    }

    onClickCancel = (): void => {
        if (this.props.onExitDialog) {
            this.props.onExitDialog();
        }
    }

    render() {
        return (
            <Modal open={true} style={{"marginTop": 0}}>
                <Modal.Header>{this.props.t("TEXT_FLAG:ADD_FLAG")}</Modal.Header>
                <Modal.Content>
                    <Table definition={true}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    {this.props.t("TEXT_FLAG:ENTER_FLAG_LABEL")}*
                                </Table.Cell>
                                <Table.Cell>
                                    <Textfield
                                        shouldAlwaysUpdate={true}
                                        maxLength={32}
                                        placeholder={this.props.t("TEXT_FLAG:ENTER_FLAG_LABEL")}
                                        value={this.state.textLabel}
                                        onChange={(event: React.FormEvent<{}>, newValue: string) => {
                                            this.setState({textLabel: newValue.substring(0, 32)});
                                        }}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    * {this.props.t("ADMIN_VIEW:MANDATORY_FIELD")}
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        icon={"checkmark"}
                        disabled={this.state.textLabel.length <= 0 || this.state.textLabel.length > 32}
                        onClick={this.onClickCreate}
                    />
                    <Button
                        icon={"ban"}
                        onClick={this.onClickCancel}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default translate(["ADMIN_VIEW","TEXT_FLAG"])(TextFlagCreationDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/FlagTab/TextFlagCreationDialog.tsx